$(function(){
    // remove empty socials
    $('.socials-list > li:empty').remove();
});